import type { FormFields, FormErrors } from './formFields'

import { FormProvider } from '@workwave-tidal/form-ui/layout'

import { useGpsAccountData } from '../hooks/useGpsAccountData'

import { useCreateFormConfig } from './hooks/useCreateFormConfig'
import { GpsAccountForm } from './GpsAccountForm'
import { formFields } from './formFields'

type Props = {
  onDiscard: () => void
}

export function GpsAccountFormProvider(props: Props) {
  const { onDiscard } = props

  // access form initial values and a function update the data when the form is saved
  const [account, updateTimezone] = useGpsAccountData()

  // create a memoized configuration including initial form valuers and form validation
  const createFormConfig = useCreateFormConfig({ timezone: account.timezone })

  return (
    <FormProvider<FormFields, FormErrors>
      name="gps-account-form"
      config={createFormConfig}
      fields={formFields}
      verbose={false}
    >
      <GpsAccountForm onDiscard={onDiscard} updateTimezone={updateTimezone} account={account} />
    </FormProvider>
  )
}
